<zah-upsert-admin
  okLabel="Voeg toe"
  (cancelClicked)="onCancelClicked()"
  (okClicked)="onAddClicked($event)">
</zah-upsert-admin>
